'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MiniBarOption = exports.MiniLineOption = exports.FunnelOption = exports.RadarOption = exports.PieOption = exports.BarOption = exports.LineOption = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 基础配置
var baseOption = {
  title: {
    text: '',
    subtext: '',
    x: 'left'
  },
  tooltip: {
    show: true,
    trigger: 'axis'
  },
  legend: {
    show: true,
    data: [],
    bottom: 'auto',
    x: 'center',
    orient: 'horizontal'
  },
  grid: {
    top: 60,
    left: '3%',
    right: '4%',
    bottom: '3%',
    containLabel: true
  },
  toolbox: {
    right: 20,
    show: true,
    feature: {
      magicType: {
        type: ['line', 'bar']
      },
      restore: {},
      saveAsImage: {}
    }
  },
  series: null,
  animation: true

  // 折线、区域图及峰谷值图
};var LineOption = exports.LineOption = (0, _assign2.default)({}, baseOption, {
  xAxis: {
    show: true,
    splitLine: {
      show: true
    },
    type: 'category',
    boundaryGap: false,
    data: []
  },
  yAxis: {
    show: true,
    splitLine: {
      show: true
    }
  }
});

// 柱状图
var BarOption = exports.BarOption = (0, _assign2.default)({}, baseOption, {
  tooltip: {
    show: true,
    trigger: 'axis',
    axisPointer: {
      type: 'shadow'
    }
  },
  xAxis: {
    show: true,
    splitLine: {
      show: true
    },
    type: 'category',
    boundaryGap: true,
    data: []
  },
  yAxis: {
    show: true,
    splitLine: {
      show: true
    }
  }
});

// 饼状图
var PieOption = exports.PieOption = (0, _assign2.default)({}, baseOption, {
  title: {
    text: '',
    subtext: '',
    x: 'center'
  },
  tooltip: {
    show: true,
    trigger: 'item',
    formatter: '{a} <br/>{b}: {c} ({d}%)'
  },
  legend: {
    show: true,
    orient: 'vertical',
    bottom: 'auto',
    x: 'left',
    data: []
  },
  toolbox: {
    right: 20,
    show: true,
    feature: {
      dataView: { readOnly: false },
      restore: {},
      saveAsImage: {}
    }
  }
});

// 雷达图
var RadarOption = exports.RadarOption = (0, _assign2.default)({}, baseOption, {
  tooltip: {},
  toolbox: {
    right: 20,
    show: true,
    feature: {
      saveAsImage: { show: true }
    }
  },
  radar: {
    radius: '60%',
    center: ['50%', '50%'],
    name: {
      textStyle: {
        color: '#fff',
        backgroundColor: '#999',
        borderRadius: 3,
        padding: [3, 5]
      }
    },
    indicator: []
  }
});

// 漏斗图
var FunnelOption = exports.FunnelOption = (0, _assign2.default)({}, baseOption, {
  tooltip: {
    show: true,
    trigger: 'item',
    formatter: '{a} <br/>{b} : {c}（{d}%）'
  },
  toolbox: {
    right: 20,
    show: true,
    feature: {
      dataView: { readOnly: false },
      restore: {},
      saveAsImage: {}
    }
  },
  calculable: true
});

// 迷你折线、区域图
var MiniLineOption = exports.MiniLineOption = (0, _assign2.default)({}, baseOption, {
  title: null,
  tooltip: {
    show: true,
    trigger: 'axis',
    axisPointer: {
      type: 'none'
    },
    formatter: '{b} {c}'
  },
  legend: null,
  grid: {
    left: 5,
    right: 5,
    top: 5,
    bottom: 5,
    containLabel: false
  },
  toolbox: null,
  xAxis: {
    show: false,
    boundaryGap: false,
    type: 'category',
    data: [] // X 轴数据
  },
  yAxis: {
    show: false
  }
});

// 迷你柱状图
var MiniBarOption = exports.MiniBarOption = (0, _assign2.default)({}, baseOption, {
  title: null,
  tooltip: {
    show: true,
    trigger: 'axis',
    axisPointer: {
      type: 'none'
    },
    formatter: '{b} {c}'
  },
  legend: null,
  grid: {
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    containLabel: false
  },
  toolbox: null,
  xAxis: {
    show: false,
    boundaryGap: true,
    type: 'category',
    data: [] // X 轴数据
  },
  yAxis: {
    show: false
  }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-chart@0.0.14@@alicd/crui-chart/lib/common/options.js
// module id = 65
// module chunks = 0